/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

// redio audio popup start

function play_redio_audio() {  
  if(localStorage.getItem("redio_popup") == 'play'){

    
   const radioButton = document.querySelector('[data-header-audio]') || null;
   const videoIframe = document.getElementById('videoIframe') || null;
    
          if (radioButton && videoIframe) {
             const videoUrl = radioButton.getAttribute('href');
              console.log(videoUrl);
            videoIframe.src = ''
            videoIframe.src = videoUrl; // Set the video URL in iframe
          }
  }
}

// redio audio popup play end


// CUSTOM PAGINATION START VK

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
// if(window.location.href.includes('?page=')){
// window.location.replace(window.location.href.split('?')[0]);
// }

 // if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-blog')){
 //    if(window.location.href.includes('?page=')){
 //      window.location.replace(window.location.href.split('?')[0]);
 //    }
 //  }

function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-main-pagination-data]");
    if(proGrid){
      // replace grid 
      // console.log(html.querySelector("[data-main-pagination-data]"))
      proGrid.innerHTML = document.querySelector("[data-main-pagination-data]").innerHTML + html.querySelector("[data-main-pagination-data]").innerHTML;
      // replace pagination
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); 
      let pagination = document.querySelector("page-pagination");
      let newPagination = html.querySelector("page-pagination");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
      }
      pagination_click_fun();
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}
// CUSTOM PAGINATION END VK



(function() {

faq_taggol();  

  newsletter_mail();


  const noty_fy = document.querySelector("[data-custom-notify-btn]") || null;
if(noty_fy){
    noty_fy.addEventListener("click", function(event) {
       event.preventDefault();
            const main_popup = document.querySelector(event.target.hash) || null;
        if(main_popup){
               main_popup.classList.add("notify-form-open");
              document.body.classList.add("popup_open");
        }
    })
}

 const popup_close = document.querySelectorAll("[data-popup-close]") || null;
if(popup_close){
     popup_close.forEach(b => {
        b.addEventListener("click", event => {
            event.preventDefault();
            const main_popup = event.target.closest("[data-poup]") || null;
            main_popup && (main_popup.classList.remove("notify-form-open"),
            document.body.classList.remove("popup_open"))
        });
     });
}
  

const header_overlay = document.querySelector("[data-banner-header-overlay_trans]") || null;
  if(header_overlay){
    document.body.classList.add('header-overlay');
  }    
// const header_operlay = document.querySelector("[data-banner-header-overlay]");
//   if(header_operlay){
//     document.body.classList.add('header-overlay');
//   }

  if(!document.body.classList.contains('template-index')){
   const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(!header_operlay){
    document.body.classList.remove('header-overlay');
  }
  }



  const revier_tragger = document.querySelectorAll('[data-review-tragger]') || null;
  if(revier_tragger){

      revier_tragger.forEach((tragger) => {
    const intro = document.querySelector(".ruk_rating_snippet") || null;
    if(intro){
        tragger.onclick = (e) => {
          e.preventDefault();
           intro.click();
        };
    }
  }); 
    
  }


  const mobile_blog = document.querySelector('[data-toggle-mobile-blog]') || null;
  if(mobile_blog){
   const mobile_blog_tragger =  mobile_blog.querySelectorAll('[data-mobile-toggle] a') || null;
    if(mobile_blog_tragger){
            mobile_blog_tragger.forEach(b => {
                    b.addEventListener("click", event => {
                       if(event.target.classList.contains("text--underlined")){
                        event.preventDefault();                      
                        mobile_blog.classList.toggle("open-dropdown");
                       }
                    });
                });
    }
}
  



  // audio popup

 const radioButton = document.querySelector('[data-header-audio]') || null;
 const videoIframe = document.getElementById('videoIframe') || null;
 const modal = document.getElementById('videoModal') || null;
const closeButton = document.querySelectorAll('[data-header-audio-close]') || null;;
  if (radioButton && videoIframe) {
    radioButton.addEventListener('click', function (event) {
      event.preventDefault();
      const videoUrl = radioButton.getAttribute('href');
        // console.log(videoUrl);
      videoIframe.src = ''
      videoIframe.src = videoUrl; // Set the video URL in iframe
        if(modal) modal.style.display = 'flex'; // Show the modal
       document.body.classList.add("popup_open");
      localStorage.setItem("redio_popup", "play");
    });
  }
  if(closeButton){
     closeButton.forEach(closebtn => {
           closebtn.addEventListener('click', function (event) {
                 event.preventDefault();
                 modal.style.display = 'none';
                 // videoIframe.src = ''; // Stop the video playback by clearing the src
              document.body.classList.remove("popup_open")
            });
        });
  }



const tab_click_all = document.querySelectorAll("[data-tabscroll-custom]");


    tab_click_all.forEach(b => {
    b.addEventListener("click", event => {
      event.preventDefault();
      const tragger_data = b.getAttribute("href") || null;
      console.log(tragger_data)
     const main_content =  document.querySelector(tragger_data) || null;
      console.log(main_content);

      if(main_content){
        smoothScrollTo(main_content, 100,10);
      }
    });
  });




            // Select the button using document.querySelector
var btn_scroll_top = document.querySelector('[data-top-scroll-custom]');

// Function to check the scroll position and show or hide the button
  if(btn_scroll_top){
function checkScroll() {
  if (window.scrollY > 300) {
    btn_scroll_top.classList.add('show');
  } else {
    btn_scroll_top.classList.remove('show');
  }
}

// Add the scroll event listener to the window
window.addEventListener('scroll', checkScroll);

// Function to smoothly scroll to the top when the button is clicked
btn_scroll_top.addEventListener('click', function(e) {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: 'smooth'  // Smooth scrolling
  });
});
  }
  


  
  
  
})();

const red_more_product = document.querySelector("[data-key-product]");
const red_more_product_toggal = document.querySelector("[data-toogle-key-feature]");
 const maindiscrption = document.querySelectorAll("[data-pdp-coll-content]") || null;
if (red_more_product && red_more_product_toggal) {
  if (!red_more_product.querySelectorAll('li').length > 3) red_more_product_toggal.setAttribute("hidden","");
  red_more_product_toggal.addEventListener("click",function(e) {
      e.preventDefault();
    // if(maindiscrption){
    //   console.log(maindiscrption[0]);
    //   maindiscrption[0].querySelector("button").click();
    // }
    smoothScrollTo(maindiscrption[0], 1000,400);
       red_more_product.classList.toggle("show_all_data");
    if(red_more_product.classList.contains('show_all_data')){
       red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-leass');
    }else{
      red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-more');
    }
    
    });
}else{
  if (red_more_product_toggal) {

      red_more_product_toggal.addEventListener("click",function(e) {
            e.preventDefault();
          // if(maindiscrption){
          //   console.log(maindiscrption[0]);
          //   maindiscrption[0].querySelector("button").click();
          // }
              smoothScrollTo(maindiscrption[0], 1000,400);
             red_more_product.classList.toggle("show_all_data");
          if(red_more_product.classList.contains('show_all_data')){
             red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-leass');
          }else{
            red_more_product_toggal.querySelector('span').innerHTML = red_more_product_toggal.getAttribute('data-read-more');
          }
          
          });
    
  }
}


const targetElement = document.querySelector('.your-element-selector');

function smoothScrollTo(element, duration,scroll_hight) {
    const targetPosition = element.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Limit to 1 (100%)
        const ease = easeInOutCubic(progress); // Easing function
        window.scrollTo(0, (startPosition + distance * ease) - scroll_hight);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }

    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    requestAnimationFrame(animation);
}

// Example usage:


class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END


// Function to open the popup
function preorderpopup_open() {
  const popup = document.getElementById('product-addtocart-popup');
  if (popup) {
    popup.classList.add("preorderpopupopen"); 
    document.body.classList.add("popup_open"); 
  }
}

// Function to close the popup
function closePreorderPopup() {
  const popup = document.getElementById('product-addtocart-popup');
  if (popup) {
    popup.classList.remove("preorderpopupopen");
    document.body.classList.remove("popup_open");
  }
}



function closeEvent() {
const closePopup = document.querySelectorAll('[data-popup-closes]') || null;
if (closePopup) {
  closePopup.forEach(b => {
    b.addEventListener("click", event => {
      event.preventDefault();
      closePreorderPopup();
    });
  });
}
  const popupButton = document.querySelector('.popup-btn');
const popupCheckbox = document.querySelector('.popup-check');

if (popupButton && popupCheckbox) {
  popupButton.addEventListener('click', function() {
    closePreorderPopup(); 
    // if (popupCheckbox.checked) {
    //   closePreorderPopup(); 
    // }
  });
}
}
closeEvent();


const gbutton = document.querySelector(".gproduct_button");
console.log("gbutton",gbutton);
  if(gbutton){
     gbutton.addEventListener('click',() =>{
     const popup = document.querySelector(".gift-cart-products");
     console.log("popup",popup);
     popup.style.display = "block";
     });
}

class clickgiftbutton extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('button');
    facetLink.addEventListener('click', this.closepopup.bind(this));
  }

  closepopup(event) {
    event.preventDefault();
    console.log("button", document.querySelector('[data-gift-drawer]'));
    document.querySelector('.open[data-gift-drawer]').style.display = "block";
  }
}
customElements.define('click-gift-button', clickgiftbutton);

class closegiftbutton extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('button');
    facetLink.addEventListener('click', this.closepopup.bind(this));
  }

  closepopup(event) {
    event.preventDefault();
    this.closest('[data-gift-drawer]').style.display = "none";
  }
}

customElements.define('close-gift-button', closegiftbutton);

//Click btn-mehr scroll to desciptions
 let btn_mehr_erfahren = document.querySelector("[btn-mehr-erfahren]") || null;
  if(btn_mehr_erfahren){
      document.querySelector('.btn-mehr-erfahren').addEventListener('click', function(event) {
          event.preventDefault();
          
          const faqWrapper = document.querySelector('.pdp-faq-blog');
          
          if (faqWrapper) {
              const offsetTop = faqWrapper.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({ top: offsetTop, behavior: 'smooth' });
              
              const firstFaqItem = faqWrapper.querySelector('.faq__item');
              
              if (firstFaqItem) {
                  const collapsibleContent = firstFaqItem.querySelector('collapsible-content');
                  if (collapsibleContent && !collapsibleContent.hasAttribute('open')) {
                      collapsibleContent.setAttribute('open', '');
                      
                      const toggleButton = firstFaqItem.querySelector('.collapsible-toggle');
                      if (toggleButton) {
                          toggleButton.setAttribute('aria-expanded', 'true');
                      }
                  }
              }
          }
      });
  }

function newsletter_mail() {
const main_serch_parth = window.location.search.split("form_type=customer") || null;

if(main_serch_parth.length == 2){
  var mailText = document.querySelector('.alrady-email') || null;
  if(mailText){
    mailText.style.display = 'block';
    setTimeout(function(){
      window.history.replaceState({}, null, window.location.href.split('?')[0]); 
    },500);
  }
   
}
}


// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
      let hide_content = document.querySelectorAll("[data-host-port-content]");
    if(document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.contains('hidden')){
      hide_content.forEach(b => {
         b.classList.add("hidden");
      });
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.remove("hidden");
    }else{
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.add("hidden");
    }
  });        
}
let host_poart_link  = document.querySelectorAll("[data-hotsport-click]");
host_poart_link.forEach(hosport_click);
// hotsport end

class ScRelatedProductItem extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-sc-related-initialized')) {
      return;
    }

    this.setAttribute('data-sc-related-initialized', '');
    this.primaryImageList = Array.from(this.querySelectorAll('.product-item__primary-image'));
    this.optionsContainer = this.querySelector('.sc-related-product-options');
    this.form = this.optionsContainer ? document.getElementById(this.optionsContainer.getAttribute('data-form-id')) : this.querySelector('form');
    this.variants = this._getVariants();
    this.productHandle = this.getAttribute('data-product-handle');
    this._handleCartRefreshBound = this._handleCartRefresh.bind(this);

    this.addEventListener('change', this._handleOptionChange.bind(this));
    this.addEventListener('click', this._handleComboBoxClick.bind(this));
    this.addEventListener('click', this._handleUnavailableOptionClick.bind(this));
    document.documentElement.addEventListener('cart:updated', this._handleCartRefreshBound);
    document.documentElement.addEventListener('cart:refresh', this._handleCartRefreshBound);

    this._syncInitialState();
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:updated', this._handleCartRefreshBound);
    document.documentElement.removeEventListener('cart:refresh', this._handleCartRefreshBound);
  }

  _handleOptionChange(event) {
    const target = event.target;

    if (!target.matches('.sc-related-product-options input[data-option-position], .sc-related-product-options select[data-option-position]')) {
      return;
    }

    this._syncVariantFromOptions(target);
  }

  _handleComboBoxClick(event) {
    const optionButton = event.target.closest('.sc-related-product-options .combo-box__option-item[role="option"]');

    if (
      !optionButton ||
      optionButton.getAttribute('data-option-state') === 'unavailable' ||
      optionButton.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    window.requestAnimationFrame(() => {
      const optionSelector = optionButton.closest('.product-form__option-selector');
      const hiddenInput = optionSelector?.querySelector('input[data-option-position][type="hidden"]');

      if (hiddenInput) {
        this._syncVariantFromOptions(hiddenInput);
      }
    });
  }

  _handleUnavailableOptionClick(event) {
    const unavailableValue = event.target.closest('[data-option-state="unavailable"] a, [data-option-state="unavailable"] button, [data-option-state="unavailable"] label');

    if (!unavailableValue || !this.contains(unavailableValue)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  }

  async _handleCartRefresh() {
    await this._refreshProductData();
    this._syncInitialState();
  }

  _syncInitialState() {
    if (!this.optionsContainer) {
      this._updateAddToCartState(this._getCurrentVariant(), false);
      return;
    }

    this._updateOptionAvailability();
    this._updateAddToCartState(this._getCurrentVariant(), false);
  }

  _syncVariantFromOptions(target) {
    const optionsContainer = target.closest('.sc-related-product-options');

    if (!optionsContainer || !this.form || this.variants.length === 0) {
      return;
    }

    const matchedVariant = this._findMatchedVariant();

    this._updateOptionDisplay(target);
    this._updateOptionAvailability();
    this._updateAddToCartState(matchedVariant, true);

    if (!matchedVariant) {
      return;
    }

    this._updateProductLinks(matchedVariant);
    this._updateWishlist(matchedVariant);
    this._updateFeaturedMedia(matchedVariant);
  }

  _getVariants() {
    if (!this.optionsContainer) {
      return [];
    }

    const variantsJson = this.optionsContainer.querySelector('script[data-variants]')?.textContent || '[]';

    try {
      return JSON.parse(variantsJson);
    } catch (error) {
      return [];
    }
  }

  _getCurrentOptionValues() {
    if (!this.optionsContainer) {
      return [];
    }

    return Array.from(
      this.optionsContainer.querySelectorAll('input[data-option-position]:checked, input[data-option-position][type="hidden"], select[data-option-position]')
    )
      .sort((a, b) => parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10))
      .map((input) => input.value);
  }

  _findMatchedVariant() {
    const optionValues = this._getCurrentOptionValues();

    return this.variants.find((variant) => {
      return this._variantMatchesOptionValues(variant, optionValues);
    }) || null;
  }

  _getCurrentVariant() {
    if (this.variants.length === 0) {
      return null;
    }

    const variantId = this.form?.querySelector('input[name="id"]')?.value;

    return this.variants.find((variant) => String(variant.id) === String(variantId)) || this.variants.find((variant) => variant.available) || this.variants[0] || null;
  }

  _updateOptionAvailability() {
    if (!this.optionsContainer || this.variants.length === 0) {
      return;
    }

    const currentOptionValues = this._getCurrentOptionValues();
    const optionInputs = Array.from(this.optionsContainer.querySelectorAll('input[data-option-position], select[data-option-position]'));

    optionInputs.forEach((input) => {
      const optionPosition = parseInt(input.getAttribute('data-option-position'), 10) - 1;
      const candidateValues = [...currentOptionValues];
      candidateValues[optionPosition] = input.value;
      const hasMatchingVariant = this.variants.some((variant) => this._variantMatchesOptionValues(variant, candidateValues));
      const hasAvailableVariant = this.variants.some((variant) => this._variantMatchesOptionValues(variant, candidateValues) && variant.available);
      const wrapper = input.closest('.color-swatch, .block-swatch, .variant-swatch');
      const clickableTarget = wrapper ? wrapper.querySelector('a, label') : input.closest('.combo-box__option-item');
      const optionState = !hasMatchingVariant ? 'unavailable' : !hasAvailableVariant ? 'sold-out' : 'available';

      if (wrapper) {
        wrapper.classList.toggle('is-disabled', optionState === 'unavailable');
        wrapper.classList.toggle('is-sold-out', optionState === 'sold-out');
        wrapper.setAttribute('data-option-state', optionState);
      }

      if (clickableTarget) {
        clickableTarget.setAttribute('aria-disabled', optionState === 'unavailable' ? 'true' : 'false');
        clickableTarget.classList.toggle('is-disabled', optionState === 'unavailable');
        clickableTarget.classList.toggle('is-sold-out', optionState === 'sold-out');
        clickableTarget.setAttribute('data-option-state', optionState);
      }
    });

    const comboBoxes = Array.from(this.optionsContainer.querySelectorAll('.combo-box'));

    comboBoxes.forEach((comboBox) => {
      const hiddenInput = comboBox.querySelector('input[data-option-position][type="hidden"]');

      if (!hiddenInput) {
        return;
      }

      const optionPosition = parseInt(hiddenInput.getAttribute('data-option-position'), 10) - 1;

      comboBox.querySelectorAll('.combo-box__option-item[role="option"]').forEach((optionButton) => {
        const candidateValues = [...currentOptionValues];
        candidateValues[optionPosition] = optionButton.value;
        const hasMatchingVariant = this.variants.some((variant) => this._variantMatchesOptionValues(variant, candidateValues));
        const hasAvailableVariant = this.variants.some((variant) => this._variantMatchesOptionValues(variant, candidateValues) && variant.available);
        const optionState = !hasMatchingVariant ? 'unavailable' : !hasAvailableVariant ? 'sold-out' : 'available';

        optionButton.classList.toggle('is-disabled', optionState === 'unavailable');
        optionButton.classList.toggle('is-sold-out', optionState === 'sold-out');
        optionButton.setAttribute('data-option-state', optionState);
        optionButton.setAttribute('aria-disabled', optionState === 'unavailable' ? 'true' : 'false');
      });
    });
  }

  _updateAddToCartState(matchedVariant, shouldUpdateIdInput) {
    const addToCartButton = this.querySelector('[data-add-to-cart-button]');
    const addToCartText = this.querySelector('[data-add-to-cart-text]');

    if (!addToCartButton || !addToCartText) {
      return;
    }

    const addToCartLabel = addToCartButton.getAttribute('data-add-to-cart-label') || '';
    const soldOutLabel = addToCartButton.getAttribute('data-sold-out-label') || addToCartLabel;
    const unavailableLabel = addToCartButton.getAttribute('data-unavailable-label') || addToCartLabel;

    let buttonLabel = addToCartLabel;
    let isDisabled = false;

    if (!matchedVariant) {
      buttonLabel = unavailableLabel;
      isDisabled = true;
    } else if (matchedVariant.available === false) {
      buttonLabel = soldOutLabel;
      isDisabled = true;
    }

    if (shouldUpdateIdInput && matchedVariant) {
      this._updateFormVariantId(this.form, matchedVariant);
    }

    addToCartButton.disabled = isDisabled;
    addToCartButton.classList.toggle('button--primary', !isDisabled && addToCartButton.classList.contains('button'));
    addToCartButton.classList.toggle('button--ternary', isDisabled && addToCartButton.classList.contains('button'));
    addToCartButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    addToCartText.textContent = buttonLabel;
  }

  _updateFormVariantId(form, matchedVariant) {
    const idInput = form.querySelector('input[name="id"]');

    if (!idInput) {
      return;
    }

    idInput.value = matchedVariant.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _updateProductLinks(matchedVariant) {
    Array.from(this.querySelectorAll('[href*="/products"]')).forEach((link) => {
      const baseUrl = link.tagName === 'A' ? link.href : link.getAttribute('href');

      if (!baseUrl) {
        return;
      }

      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('variant', matchedVariant.id);
      link.setAttribute('href', url.toString());
    });
  }

  _updateWishlist(matchedVariant) {
    const wishlistButton = this.querySelector('.swym-add-to-wishlist-view-product');

    if (wishlistButton) {
      wishlistButton.setAttribute('data-variant-id', matchedVariant.id);
    }
  }

  _updateOptionDisplay(target) {
    const optionSelector = target.closest('.product-form__option-selector');

    if (!optionSelector) {
      return;
    }

    const optionValueElement = optionSelector.querySelector('.product-form__option-value');

    if (!optionValueElement) {
      return;
    }

    if (optionSelector.getAttribute('data-option-is-color') === 'true') {
      const selectedSwatch = target.closest('.color-swatch')?.querySelector('.color-swatch__item');
      const selectedMiniSwatch = optionValueElement.querySelector('.color-swatch__item');
      const selectedMiniSwatchWrapper = optionValueElement.querySelector('.color-swatch');

      if (selectedSwatch && selectedMiniSwatch && selectedMiniSwatchWrapper) {
        selectedMiniSwatch.setAttribute('style', selectedSwatch.getAttribute('style') || '');
        selectedMiniSwatchWrapper.classList.toggle(
          'color-swatch--white',
          target.closest('.color-swatch')?.classList.contains('color-swatch--white') || false
        );
      }

      return;
    }

    const textTarget = optionSelector.querySelector('.select__selected-value') || optionValueElement;
    textTarget.textContent = target.value;
  }

  _updateFeaturedMedia(matchedVariant) {
    const variantFeaturedMediaId = matchedVariant.featured_media?.id ? String(matchedVariant.featured_media.id) : null;

    if (!variantFeaturedMediaId) {
      return;
    }

    const newImage = this.primaryImageList.find((image) => image.getAttribute('data-media-id') === variantFeaturedMediaId);

    if (!newImage) {
      return;
    }

    newImage.removeAttribute('hidden');

    this.primaryImageList
      .filter((image) => image.classList.contains('product-item__primary-image') && image !== newImage)
      .forEach((image) => image.setAttribute('hidden', ''));
  }

  _variantMatchesOptionValues(variant, optionValues) {
    return optionValues.every((optionValue, index) => {
      const variantOptionValue = (variant.options && variant.options[index]) || variant[`option${index + 1}`];
      return variantOptionValue === optionValue;
    });
  }

  async _refreshProductData() {
    if (!this.productHandle) {
      return;
    }

    try {
      const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${this.productHandle}.js?timestamp=${Date.now()}`);

      if (!response.ok) {
        return;
      }

      const product = await response.json();

      if (!product || !Array.isArray(product.variants)) {
        return;
      }

      this.variants = product.variants;
    } catch (error) {
      return;
    }
  }
}

if (!customElements.get('sc-related-product-item')) {
  customElements.define('sc-related-product-item', ScRelatedProductItem);
}

/**
 * PDP: Der Variantenwechsel ersetzt den product-meta Block mit leerem Reviews.io Platzhalter
 * (.ruk_rating_snippet). Reviews.io wird nur einmal beim Laden initialisiert, daher hier gezielt
 * nur dann neu befüllen, wenn ein leerer Platzhalter vorhanden ist. Optionen wie in sections/footer.liquid.
 */
document.addEventListener('variant:changed', function (event) {
  // Nur das Hauptformular der PDP (product-rerender), keine Quick-Buy- oder Featured-Formulare
  const form = event.target;
  if (!form || !form.closest || !form.closest('product-rerender') || !String(form.getAttribute('id')).startsWith('product-form-main-')) return;
  // product:rerender wird direkt nach variant:changed ausgelöst; danach erst prüfen
  setTimeout(function () {
    if (typeof window.ratingSnippet !== 'function') return;
    // Pro Platzhalter nur einmal initialisieren (auch bei schnellen Wechseln)
    const fresh = Array.from(form.closest('product-rerender').querySelectorAll('.ruk_rating_snippet')).filter(function (el) {
      return !el.innerHTML.trim() && !el.hasAttribute('data-ak-rating-init');
    });
    if (!fresh.length) return;
    fresh.forEach(function (el) { el.setAttribute('data-ak-rating-init', ''); });
    window.ratingSnippet('ruk_rating_snippet', {
      store: 'ankelinerherz.com',
      mode: 'default',
      color: '#f9c00b',
      linebreak: false,
      text: 'Bewertungen',
      singularText: 'Bewertung',
      lang: 'de',
      usePolaris: true,
      showEmptyStars: false,
    });
  }, 0);
});

/**
 * PDP: Wird eine Größe gewählt, solange theme.js (defer) den variant-picker noch nicht registriert hat, schaltet der
 * Klick nur das Radio nativ um. Beim Start übernimmt die Komponente die serverseitige Variante, das Formular sendet
 * dann die alte Variante, obwohl die neue sichtbar ausgewählt ist. Einmaliger Abgleich nach der Registrierung: Weicht
 * ein gewähltes Radio vom Serverstand (defaultChecked) ab, wird dessen change-Event ausgelöst, auf das die Theme-Logik
 * selbst hört. Nur Hauptformular der PDP, keine Wartezeit.
 */
if (window.customElements) {
  window.customElements.whenDefined('variant-picker').then(function () {
    document.querySelectorAll('product-rerender variant-picker[form-id^="product-form-main-"]').forEach(function (picker) {
      var formId = picker.getAttribute('form-id');
      var changed = Array.from(picker.querySelectorAll('input[type="radio"][data-option-position]')).filter(function (input) {
        return input.getAttribute('form') === formId && input.checked && !input.defaultChecked;
      });
      // Die Theme-Logik liest beim change alle aktiven Optionen aus dem Formular, ein Event genügt
      if (changed.length) changed[changed.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

/**
 * PDP: Kaufsperre während einer offenen Variantenauswahl (nur Hauptformular der Produktseite).
 * Das Theme setzt die Formularvariante erst, wenn die Antwort zur neuen Auswahl da ist. Ein Kauf in dieser Zeit
 * hätte die vorige Variante in den Warenkorb gelegt. theme.js meldet variant:selection-start/-end/-error und verwirft
 * verspätete Antworten. Hier wird der Kauf gesperrt, solange eine Auswahl offen oder fehlgeschlagen ist.
 * Eine sichtbar gewählte, noch nicht angefragte Option (checked ohne defaultChecked) fängt ProductForm in theme.js
 * selbst ab, auch bevor custom.js geladen ist.
 * Der Wächter sitzt auf dem submit-Ereignis (Capture) und greift damit für Kaufbutton, Sticky-Button und Enter.
 * Gesperrte Klicks werden verworfen, nicht später ausgeführt.
 */
(function () {
  if (window.__ankerherzVariantLock) return;
  window.__ankerherzVariantLock = true;

  var MAIN_FORM_PREFIX = 'product-form-main-';
  // Dauert eine Auswahl länger, erklärt ein Hinweis die Sperre. Die Anfrage läuft weiter (theme.js bricht erst nach
  // VARIANT_REQUEST_TIMEOUT ab, dann Fehlerzustand mit "Erneut laden"); kommt ihre Antwort vorher, gibt selection-end frei.
  var SLOW_SELECTION_MS = 15000;
  var MESSAGES = {
    slow: 'Die gewählte Größe lädt länger als üblich. Der Warenkorbbutton bleibt gesperrt, bis sie geladen ist, damit keine falsche Größe bestellt wird.',
    failed: 'Die gewählte Größe konnte nicht geladen werden. Der Warenkorbbutton ist gesperrt, damit keine falsche Größe bestellt wird.'
  };
  var pending = {};
  var failed = {};
  var slow = {};
  var slowTimers = {};

  function clearSlowTimer(formId) {
    if (slowTimers[formId]) {
      clearTimeout(slowTimers[formId]);
      delete slowTimers[formId];
    }
  }

  function isMainForm(formId) {
    return typeof formId === 'string' && formId.indexOf(MAIN_FORM_PREFIX) === 0;
  }

  function getPicker(formId) {
    return document.querySelector('product-rerender variant-picker[form-id="' + formId + '"]');
  }

  // Gewählte Optionen: Radios (Darstellung "block") und das versteckte Feld der Dropdown-Auswahl (combo-box)
  function getCheckedOptions(formId) {
    var picker = getPicker(formId);
    if (!picker) return [];
    return Array.from(picker.querySelectorAll('input[type="radio"][data-option-position], input[type="hidden"][data-option-position]')).filter(function (input) {
      return input.getAttribute('form') === formId && (input.type === 'hidden' || input.checked);
    });
  }

  function requestSelection(formId) {
    var checked = getCheckedOptions(formId);
    // Die Theme-Logik liest beim change alle aktiven Optionen aus dem Formular, ein Event genügt
    if (checked.length) checked[checked.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
  }

  function isLocked(formId) {
    return !!pending[formId] || !!failed[formId];
  }

  // "Größe:" zeigt per CSS (we-site.css) "wird geladen", solange die Auswahl offen ist, bei Fehler "nicht geladen"
  function setLabelFailed(formId, on) {
    var picker = getPicker(formId);
    if (!picker) return;
    if (on) picker.setAttribute('data-variant-load', 'failed'); else picker.removeAttribute('data-variant-load');
  }

  function getSubmitButtons(form) {
    return Array.from(form.elements).filter(function (element) { return element.type === 'submit'; });
  }

  // state: 'loading' (Spinner des Themes über aria-busy), 'failed' (aria-disabled) oder null (freigeben)
  function setButtonState(form, state) {
    getSubmitButtons(form).forEach(function (button) {
      var current = button.getAttribute('data-variant-lock');
      if (current === state) return;
      if (current === 'loading') button.removeAttribute('aria-busy');
      if (current === 'failed') button.removeAttribute('aria-disabled');
      if (state === 'loading') button.setAttribute('aria-busy', 'true');
      if (state === 'failed') button.setAttribute('aria-disabled', 'true');
      if (state) button.setAttribute('data-variant-lock', state); else button.removeAttribute('data-variant-lock');
    });
  }

  // getFormId(form) liefert hier das Feld name="id", deshalb immer das Attribut lesen
  function getFormId(form) {
    return form.getAttribute('id');
  }

  function getMessageHost(form) {
    var picker = getPicker(getFormId(form));
    var block = form.closest('[data-block-type="buy-buttons"]') || (picker && picker.closest('[data-block-type="variant-picker"]'));
    return block || form.parentElement;
  }

  function removeMessage(form) {
    var host = getMessageHost(form);
    var message = host && host.querySelector('.variant-lock-message');
    if (message) message.remove();
  }

  // kind: 'slow' (Anfrage läuft noch, dauert länger als üblich; ohne Knopf) oder 'failed' (gescheitert oder
  // abgebrochen; mit "Erneut laden"). Ein vorhandener Hinweis wird umgestellt, nicht verdoppelt.
  function showMessage(form, kind) {
    var host = getMessageHost(form);
    if (!host) return;
    var message = host.querySelector('.variant-lock-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'variant-lock-message';
      message.setAttribute('role', 'alert');
      message.appendChild(document.createElement('p'));
      host.appendChild(message);
    }
    var text = message.querySelector('p');
    var textContent = kind === 'slow' ? MESSAGES.slow : MESSAGES.failed;
    if (text.textContent !== textContent) text.textContent = textContent;
    var retry = message.querySelector('.variant-lock-message__retry');
    if (kind === 'slow') {
      if (retry) retry.remove();
    } else if (!retry) {
      retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'variant-lock-message__retry';
      retry.textContent = 'Erneut laden';
      retry.addEventListener('click', function () { requestSelection(getFormId(form)); });
      message.appendChild(retry);
    }
  }

  // Gesperrter Kauf über den Sticky-Button (Kaufbereich nicht im Bild) oder Hinweis außerhalb des Bildes:
  // Hinweis in die Mitte holen und "Erneut laden" fokussieren. Klicks im sichtbaren Kaufbereich bleiben unverändert.
  function revealMessage(form, submitter) {
    var host = getMessageHost(form);
    var message = host && host.querySelector('.variant-lock-message');
    if (!message) return;
    var fromSticky = !!(submitter && submitter.closest && submitter.closest('product-sticky-form'));
    var rect = message.getBoundingClientRect();
    if (!fromSticky && rect.top >= 0 && rect.bottom <= window.innerHeight) return;
    message.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var retry = message.querySelector('.variant-lock-message__retry');
    if (retry) retry.focus({ preventScroll: true });
  }

  document.addEventListener('variant:selection-start', function (event) {
    var form = event.target;
    var formId = event.detail && event.detail.formId;
    if (!isMainForm(formId) || !(form instanceof HTMLFormElement)) return;
    var requestId = event.detail.requestId;
    pending[formId] = requestId;
    delete failed[formId];
    delete slow[formId];
    setLabelFailed(formId, false);
    removeMessage(form);
    setButtonState(form, 'loading');
    clearSlowTimer(formId);
    slowTimers[formId] = setTimeout(function () {
      delete slowTimers[formId];
      if (pending[formId] !== requestId) return;
      // Ladeanzeige und Sperre bleiben, nur der erklärende Hinweis kommt dazu
      slow[formId] = true;
      showMessage(form, 'slow');
    }, SLOW_SELECTION_MS);
  });

  document.addEventListener('variant:selection-end', function (event) {
    var form = event.target;
    var formId = event.detail && event.detail.formId;
    if (!isMainForm(formId) || pending[formId] !== event.detail.requestId) return;
    clearSlowTimer(formId);
    delete pending[formId];
    // Antwort kam nach dem Hinweis "lädt länger als üblich": Hinweis entfernen (selection-start hat jeden älteren entfernt)
    if (slow[formId]) {
      delete slow[formId];
      removeMessage(form);
    }
    // Nach dem Rerender sind die Buttons neu (ohne Sperre); falls nicht ersetzt, Sperre hier lösen
    setButtonState(form, null);
  });

  document.addEventListener('variant:selection-error', function (event) {
    var form = event.target;
    var formId = event.detail && event.detail.formId;
    if (!isMainForm(formId) || pending[formId] !== event.detail.requestId) return;
    clearSlowTimer(formId);
    delete pending[formId];
    delete slow[formId];
    failed[formId] = true;
    setButtonState(form, 'failed');
    setLabelFailed(formId, true);
    showMessage(form, 'failed');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var formId = getFormId(form);
    if (!isMainForm(formId) || !isLocked(formId)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // Gesperrter Klick: vorhandenen Hinweis zeigen (Fehler oder "lädt länger"), in den ersten Sekunden genügt die Ladeanzeige
    if (failed[formId] || slow[formId]) {
      showMessage(form, failed[formId] ? 'failed' : 'slow');
      revealMessage(form, event.submitter);
    }
  }, true);
})();

/**
 * PDP (Vorlage we_pdp): Geschenkverpackung der App Wrapped nur mitsenden, wenn sie sichtbar gewählt ist.
 * Wrapped legt beim Anhaken versteckte Felder in das Hauptformular: Eigenschaften der Zeile und die Verpackung als
 * zusätzlichen Artikel. Nach einer Warenkorbänderung (z. B. Menge im Drawer erhöht, Empfehlung hinzugefügt) baut die App
 * ihren Block neu auf. Der Haken steht dann auf "nicht gewählt", die Felder bleiben aber im Formular, und der nächste
 * Kauf legt die Verpackung kostenpflichtig mit in den Warenkorb (gemessen 09.10.2026, auch mit dem unveränderten Theme).
 * Beim Absenden werden deshalb die Wrapped-Felder entfernt, wenn der Haken des Wrapped-Blocks dieser Produktseite nicht
 * gesetzt ist. Ohne auffindbaren Haken (App nicht geladen, andere Darstellung) bleibt alles so, wie die App es setzt.
 * Wie die Kaufsperre oben auf dem submit-Ereignis (Capture), also vor dem Kaufrequest aus theme.js.
 */
(function () {
  if (window.__ankerherzWrappedGuard) return;
  window.__ankerherzWrappedGuard = true;

  // Feldnamen wie im Wrapped-Skript (Stand 09.10.2026): Eigenschaften laut window.Wrapped.options.product.datafields,
  // dazu Varianten-ID und Bündelkennung; die Verpackung selbst als zusätzlicher Artikel mit dem festen Index 4242
  var FALLBACK_PROPERTIES = ['Gift Wrap', 'Gift Message', 'Gift Sender', 'Gift Receiver', 'Gift Option'];
  var FIXED_PROPERTIES = ['_Gift Option ID', '_Wrapped Bundle'];
  var ITEM_PREFIXES = ['items[4242]', 'shopify-additional-items[4242]'];

  function propertyNames() {
    var options = window.Wrapped && window.Wrapped.options;
    var datafields = options && options.product && options.product.datafields;
    var names = datafields ? Object.keys(datafields).map(function (key) { return datafields[key]; }) : FALLBACK_PROPERTIES;
    return names.concat(FIXED_PROPERTIES).filter(Boolean).map(function (name) { return 'properties[' + name + ']'; });
  }

  function wrappedInputs(form) {
    var properties = propertyNames();
    return Array.from(form.querySelectorAll('input[type="hidden"]')).filter(function (input) {
      var name = input.name || '';
      return properties.indexOf(name) !== -1 || ITEM_PREFIXES.some(function (prefix) { return name.indexOf(prefix) === 0; });
    });
  }

  // Haken des Wrapped-Blocks im Produktbereich dieses Formulars (Block und Formular liegen nebeneinander in .product-form)
  function wrappedCheckboxes(form) {
    var scope = form.closest('.product') || document;
    return Array.from(scope.querySelectorAll('wrapped-extension[target-group="product-page"]')).map(function (host) {
      if (host.getAttribute('hidden-checkbox') === 'true') return null;
      return host.shadowRoot && host.shadowRoot.querySelector('input[type="checkbox"]');
    }).filter(Boolean);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !document.body.classList.contains('template-we_pdp')) return;
    if (String(form.getAttribute('id')).indexOf('product-form-main-') !== 0) return;
    var inputs = wrappedInputs(form);
    if (!inputs.length) return;
    var checkboxes = wrappedCheckboxes(form);
    if (!checkboxes.length || checkboxes.some(function (checkbox) { return checkbox.checked; })) return;
    inputs.forEach(function (input) { input.remove(); });
  }, true);
})();

// Listify navigation entry: close the mobile menu and let the native #wishlist trigger handle the click.
document.addEventListener('click', function (event) {
  var entry = event.target.closest('[data-listify-menu-entry]');
  if (!entry) return;

  var mobileNavigation = entry.closest('mobile-navigation');
  if (mobileNavigation) mobileNavigation.open = false;
});

// Listify writes display:block!important inline. Reapply the seasonal decision after app renders or mutates the host.
(function suppressListifyFloatingTrigger() {
  var observedTrigger = null;
  var triggerStyleObserver = null;

  function hideTrigger() {
    var trigger = document.getElementById('listify-trigger-root');
    if (!trigger) return;

    if (trigger.style.getPropertyValue('display') !== 'none' || trigger.style.getPropertyPriority('display') !== 'important') {
      trigger.style.setProperty('display', 'none', 'important');
    }

    if (trigger !== observedTrigger) {
      if (triggerStyleObserver) triggerStyleObserver.disconnect();
      observedTrigger = trigger;
      triggerStyleObserver = new MutationObserver(hideTrigger);
      triggerStyleObserver.observe(trigger, { attributes: true, attributeFilter: ['style'] });
    }
  }

  hideTrigger();
  document.addEventListener('DOMContentLoaded', hideTrigger, { once: true });
  new MutationObserver(hideTrigger).observe(document.documentElement, { childList: true, subtree: true });
})();

// Listify card hearts sit 3px above the 44px mobile host because the shadow wrapper uses baseline flow.
(function centerListifyProductCardHearts() {
  var selector = '.collection-wishlist-main-wapper [data-wishlist-button]';
  var pendingHosts = new WeakSet();

  function applyCentering(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    if (root.querySelector('style[data-ah-listify-card-center]')) return true;

    var style = document.createElement('style');
    style.setAttribute('data-ah-listify-card-center', '');
    style.textContent = '@media (max-width: 740px) { :host > div { width: 100% !important; height: 100% !important; display: flex !important; align-items: center !important; justify-content: center !important; } }';
    root.appendChild(style);
    return true;
  }

  function bindHost(host) {
    if (applyCentering(host) || pendingHosts.has(host)) return;

    pendingHosts.add(host);
    var attempts = 0;

    function retry() {
      if (applyCentering(host) || attempts >= 20) {
        pendingHosts.delete(host);
        return;
      }

      attempts += 1;
      window.setTimeout(retry, 500);
    }

    retry();
  }

  function scan(root) {
    if (root instanceof Element && root.matches(selector)) bindHost(root);
    root.querySelectorAll && root.querySelectorAll(selector).forEach(bindHost);
  }

  scan(document);
  document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        scan(mutation.target);
      }
      mutation.addedNodes.forEach(function (node) {
        if (node instanceof Element) scan(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-wishlist-button']
  });
})();
